export const LANDLORD_STATUS = {
  NOT_STARTED: 'notStarted',
  ONBOARDING_STARTED: 'onboardingStarted',
  EXTERNAL_ACCOUNT_SET: 'externalAccountSet',
  IDENTITY_VERIFICATION_PENDING: 'identityVerificationPending',
  IDENTITY_VERIFIED: 'identityVerified',
  ADDITIONAL_VERIFICATION_NEEDED: 'additionalVerificationNeeded',
  ON_HOLD: 'onHold',
};

export const PROPERTY_STATUS = {
  NOT_STARTED: 'notStarted',
  // NOTE: Not used
  RENT_TERMS_SET: 'rentTermsSet',
  TENANT_INFO_SET: 'tenantInfoSet',
  TERM_COMPLETE: 'termComplete',
  TERM_EXPIRED: 'termExpired',
};

export const ID_VERIFICATION_STATUS = {
  THIN_FILE: 'THIN_FILE',
  FROZEN: 'FROZEN',
  NOT_IDENTIFIED: 'NOT_IDENTIFIED',
  LOCKED_OUT_PREVIOUSLY_IDENTIFIED: 'LOCKED_OUT_PREVIOUSLY_IDENTIFIED',
  LOCKED_OUT_NOT_IDENTIFIED: 'LOCKED_OUT_NOT_IDENTIFIED',
  PREVIOUSLY_IDENTIFIED: 'PREVIOUSLY_IDENTIFIED',
  CURRENTLY_IDENTIFIED: 'CURRENTLY_IDENTIFIED',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  FROZEN_CREDIT_REPORT: 'FROZEN_CREDIT_REPORT',
  SSN_REQUIRED: 'SSN_REQUIRED',
};
